function removeCheckedElements(elements)
{
  Array.from(elements).forEach(function(element) {
    element.classList.remove("checked");
  });
}

function checkPhone(id, index) {
  if (!$("#phone" + index).val()) {
    $(id).show();
    $("#phone" + index).css("border", "1px solid red");
    return false;
  }
  return true;
}

function openPopupDevolution() {
  $('body').modal({
    remote: '/customer/order/devolution/',
    backdrop: 'static',
    keyboard: false
  });
  $('.select').each(function(i, obj) {
    if ($('#phone'+(i+1)).val().length > 0) {
      $(obj).trigger("mouseover");
    }
  });
}

function appendElement(index, id_pickup_address) {
  var html = "<div class='spacer' style='height: 10px'>&nbsp</div>";
  html += "<div class='selectedPlace'><span style='color: #000000;'>Ponto escolhido:</span> ";
  html += "<br><span style='font-weight: bold; color:#000000;'>" + $('#name'+index).text() + "</span>";
  html += "<div style='height: 5px'>&nbsp</div>";
  html += $('#address'+index).text();
  html += "<br>" + $('#district'+index).text();
  html += "<div style='height: 5px'>&nbsp</div>";
  html += "<span style='color: #000000'>" + $('#time'+index).text() + "</span>"
  html += "<div style='height: 5px'>&nbsp</div>";
  html += "<a href='#' onclick='openPopupDevolution();' style='color: #17B687;'>Editar</a>";
  html += "</div>";
  $('.selectedPlace').remove();
//   $('#selectedPlaceSelected').remove();
  $('.spacer').remove();
//   $('input:radio[value=convenience]').parent().append(html);

  var selectedPlaceSelected = $('#selectedPlaceSelected');
  selectedPlaceSelected.html(html)
  selectedPlaceSelected.css({
    display: "flex",
    justifyContent: "center"
  })
  $('#convenience').addClass("checked");
  $('#collect').removeClass("checked");
  $('#post').removeClass("checked");
//   $('selectedPlace').parent().append(html);
  $('#id_return_point_hidden').text(id_pickup_address);
  $('#return_phone_hidden').text($('#phone' + index).val());
}

function appendElementMobile(index, id_pickup_address) {
  var html = "<div class='spacer' style='height: 10px'>&nbsp</div>";
  html += "<div class='selectedPlace'><span style='color: #000000;'>Ponto escolhido:</span> ";
  html += "<br><span style='font-weight: bold; color:#000000;'>" + $('#name' + index).text() + "</span>";
  html += "<div style='height: 5px'>&nbsp</div>";
  html += "<span style='color: #858585;'>" + $('#address' + index).text() + "</span>";
  html += "<br><span style='color: #858585;'>" + $('#district' + index).text() + "</span>";
  html += "<div style='height: 5px'>&nbsp</div>";
  html += "<span style='color: #000000'>" + $('#time' + index).text() + "</span>"
  html += "<div style='height: 5px'>&nbsp</div>";
  html += "<a href='#' onclick='showModalMobile(" + index + ",\"" + $('#phone' + index).val() + "\");' style='color: #17B687;'>Editar</a>";
  html += "</div>";
  $('.selectedPlace').remove();
  $('.spacer').remove();
  $('input:radio[value=convenience]').parent().append(html);
  $(document).scrollTop($(".selectedPlace").offset().top);

  $('#id_return_point_hidden').text(id_pickup_address);
  $('#return_phone_hidden').text($('#phone' + index).val());
}

function mtel(v, id){
    $(id).hide();
    $("#phone").css("border", "");
    v=v.replace(/\D/g,"");             //Remove tudo o que não é dígito
    v=v.replace(/^(\d{2})(\d)/g,"($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
    v=v.replace(/(\d)(\d{3})$/,"$1-$2");    //Coloca hífen entre o quarto e o quinto dígitos
    return v;
}

function maskTel(element, id) {
  element.value = mtel(element.value, id);
}

function showConfirm(index, id, button, select) {
  $(id).show();
  $(select).css("background-color","#F0F0F0");
  $(button).hide();
  $('.select').each(function(i, obj) {
    if ((i+1) !== index) {
      $('#phone'+(i+1)).val('');
      $('#button'+(i+1)).hide();
      $('#confirm'+(i+1)).hide();
      $('#select'+(i+1)).css("background-color","#FFFFFF");
    }
  });
}

function selectDevolution(index) {
  if ($('#phone'+index).val().length > 0) {
    $('#confirm'+index).show();
  }
  $('#select'+index).css("background-color","#F0F0F0");
  if (!$('#confirm'+index).is(":visible")) {
    $('#button'+index).show();
  }
  $('#confirm-error'+index).hide();
  $('.select').each(function(i, obj) {
    if ((i+1) !== index && $('#phone'+index).val().length === 0) {
      $(obj).trigger("mouseout");
    }
    if ($('#phone'+(i+1)).val().length > 0) {
      $('#confirm'+(i+1)).show();
      $('#select'+(i+1)).css("background-color","#F0F0F0");
      $('#confirm-error'+(i+1)).hide();
    }
  });
}

function unselectDevolution(event, index) {
  event.stopPropagation(); //cancel bubbling
  var ele = event.target || event.srcElement
  if (ele.id === "select"+index){
    $('#button'+index).hide();
    $('#confirm'+index).hide();
    $('#select'+index).css("background-color","#FFFFFF");
  }
}

function handleDevolutionClick(element) {
  removeCheckedElements($('#devolution-fieldset-line').children());
  $('#convenience').addClass("checked");
  $('#convenience').removeClass('opacity');
  addOpacityUnselectedDevolutionsMethod('convenience');
  changeIconForSelectedDevolutionsMethod('convenience_icon');
  verifyOptionsIsSelectedIsCollect('convenience');
  verifyOptionsIsSelectedAndChangeConfirmButtonState();
  $('.selectedPlacePost').remove();
  $('.selectedPlace').remove();
  $('#return_phone_hidden').text("");
  $('#id_return_point_hidden').text("");
  $('.spacer').remove();

  if (element.srcElement.value === 'convenience') {
    $('body').modal('destroy');
    $('body').removeData('dft.modal');
    $('body').modal({
      remote: window.secureUrl + '/customer/order/devolution/',
      doNotClose: true
    });
  }  else if (element.srcElement.value === 'collect') {
    var html = "<div class='spacer' style='height: 10px'>&nbsp</div>";
    inCollectId.show()
  }
}

function showModalMobile(index, phone) {
  $('body').modal('destroy');
  $('body').removeData('dft.modal');
  if (phone === undefined) {
    phone = '';
  }
  remote = window.secureUrl + '/customer/order/devolution/?index=' + encodeURIComponent(index) + '&phone=' + encodeURIComponent(phone);
  $('body').modal({
    className: 'devolutionMobile',
    remote: remote
  });
}

function handleDevolutionClickMobile(element) {
  removeCheckedElements($('#devolution-fieldset-line').children());
  $('#convenience').addClass("checked");
  $('#convenience').removeClass('opacity');
  addOpacityUnselectedDevolutionsMethod('convenience');
  changeIconForSelectedDevolutionsMethod('convenience_icon');
  verifyOptionsIsSelectedIsCollect('convenience');
  verifyOptionsIsSelectedAndChangeConfirmButtonState()
  $('.selectedPlacePost').remove();
  $('.selectedPlace').remove();

  if (element.target.value === 'convenience') {
    showModalMobile();
  } else if (element.target.value === 'post') {
    var html = "<div class='spacer' style='height: 10px'>&nbsp</div>";
    html += "<div class='selectedPlacePost'>";
    html += "Não esqueça que o produto deve ser devolvido em sua embalagem original ou embrulhado em papel pardo, acompanhado dos manuais, acessórios e nota fiscal. Realizar postagem em até 48 horas. Ficou com alguma dúvida? O site dos Correios explica tudo <a href=\"https://mais.correios.com.br/app/index.php\" class=\"package-link\" target=\"_blank\">aqui.</a>";
    html += "</div>";
    $('.selectedPlacePost').remove();
    $('.spacer').remove();
    $('input:radio[value=post]').parent().append(html);
  } else if (element.target.value === 'collect') {
    inCollectId.show()
  }
}

function getBankCode(bank) {
  return bank.substring(0, bank.indexOf(" "));
}

function exchangeMessageModal(content, size) {
  $('body').modal('destroy');
  $('body').removeData('dft.modal');
  $('body').modal({'content': content});
};

function exchangeModalJustMessage (title, link) {
  return '<div class="modal-content message-modal-content"> \
            <div class="modal-header"> \
                <div class="row"> \
                    <div class="col-12"> \
                        <button type="button" class="modal-close icon-cross close modal-banner-button" data-dismiss="modal" aria-hidden="true"></button> \
                        <h1> \
                            Atenção \
                        </h1> \
                    </div> \
                </div> \
            </div> \
            <div class="modal-body" style="margin-top: 10px;"> \
                <div class="row"> \
                    <div class="col-12">'
                      +  title +
                    '</div> \
                </div> \
            </div> \
          </div>';
};

function showReplacementMethodOptions(element) {
  var choice = element.value;
  var in_credit = $('#replacement-fieldset-line').attr('data-in-credit');

  $('#account-holder').hide();
  $('#bank-account').hide();
  $('#voucher-description').hide();
  $('#product-options-wrapper').hide();
  $('.exchange_warning').hide();

  if (choice == 'refund' && in_credit === 'N') {
    $('#bank-account').show();
  }

  if (choice == 'refund' && in_credit === 'S') {
    $('#account-holder').show();
  }

  if (choice == 'voucher') {
    $('#voucher-description').show();
  }

  if (choice == 'replace') {
    $('#product-options-wrapper').show();
    $('.exchange_warning').show();
    $('.voucher_warning').hide();
  }

  var voucherLabel = $('.customer-exchange-return-label-voucher');

  if(voucherLabel.length) {
    voucherLabel.hide();
    voucherLabel.get(0).offsetHeight;
    voucherLabel.show();
  }
}


$(document).ready(function () {
    $(document).on(
      "change",
      'input[type="radio"][name="OrderForm[account_holder_is_accountable]"]',
      function () {
          $("#joint_account").hide();
          var choice = this.value;
          if (choice === "yes") {
              $("#joint_account").show();
          } else {
            if($('#submit_exchange_request').hasClass('dafiti-exchange')) {
                exchangeMessageModal(exchangeModalJustMessage('O CPF utilizado para depósito deverá ser o titular da conta'), '320,109');
              } else {
                alert('O CPF utilizado para depósito deverá ser o titular da conta');
              }
          }
      }
    );
    $(document).on(
      "change",
      'input[type="radio"][name="OrderForm[joint_account]"]',
      function () {
          $("#bank-account").hide();
          var choice = this.value;
          if (choice === "yes") {
              $("#bank-account").show();
          } else {
              if($('#submit_exchange_request').hasClass('dafiti-exchange')) {
                exchangeMessageModal(exchangeModalJustMessage('Caso seja conta conjunta, é necessario ser primeiro titular da conta'), '320,109');
              }else {
                alert('Caso seja conta conjunta, é necessario ser primeiro titular da conta');
              }
          }
      }
    );

    $(document).on('click', '[data-submit-exchange-request]', function(event){
        event.preventDefault();

        var reasonTextarea = null;
        if (($("#reason-text-fieldset")).length != 0) {

            var reasonTextarea = $('#OrderForm_reason_text').val();
            if(reasonTextarea == '')
            {

                $('#OrderForm_reason_text').focus();

                if($('.submit_exchange_request').hasClass('dafiti-exchange')) {
                    exchangeMessageModal(exchangeModalJustMessage('Detalhe o motivo da sua troca'), '320,109');
                    return;
                }

                alert('Detalhe o motivo da sua troca');
                return;

            }

        }

        var devolutionMethod = null;
        if (($("#devolution-fieldset-line")).length != 0) {

            devolutionMethod = $('input[name="OrderForm[devolution_method]"]:checked').val();
            if(devolutionMethod == undefined)
            {

                if($(this).hasClass('dafiti-exchange')) {
                    exchangeMessageModal(exchangeModalJustMessage('Escolha um método de devolução.'), '320,109');
                    return;
                }

                alert('Escolha um método de devolução.');
                return;
            }

        }

        var packageOption = 'no';
        var replacementMethods = null;
        var newsku = null;

        var bank = null;
        var agency = null;
        var agencyDigit = null;
        var account = null;
        var accountDigit = null;
        var accountType = null;
        var in_credit = $('#replacement-fieldset-line').attr('data-in-credit');
        var type_refund_input = $('#type_refund');
        var type_refund_value = null;

        if (($("#replacement-fieldset-line")).length != 0) {

            replacementMethods = $('input[name="OrderForm[replacement_methods]"]:checked').val();
            if(replacementMethods == undefined)
            {

                if($(this).hasClass('dafiti-exchange')) {
                    exchangeMessageModal(exchangeModalJustMessage('Escolha uma opção para troca/devolução'), '320,109');
                    return;
                }

                alert('Escolha uma opção para troca/devolução');
                return;
            }

            if(replacementMethods == 'replace')
            {
                newsku = $(".selected").attr("id");
                if(newsku == undefined)
                {

                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Escolha um tamanho para troca'), '320,109');
                        return;
                    }

                    alert('Escolha um tamanho para troca');
                    return;
                }
            }

            if (replacementMethods == 'refund') {
              if (type_refund_input) {
                type_refund_value = type_refund_input.val()
              }
            }

            if(replacementMethods == 'refund' && in_credit === 'S')
            {
                bank = $("#OrderForm_bank").val();
                accountable_purchase = $('input[type="radio"][name="OrderForm[account_holder_is_accountable]"]:checked').val();
                joint_account = $('input[type="radio"][name="OrderForm[joint_account]"]:checked').val();

                if (accountable_purchase === undefined || joint_account === undefined) {
                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Somente o titular da conta pode receber a restituição.'), '320,109');
                        return;
                      }

                    alert('Somente o titular da conta pode receber a restituição.');
                    return;
                }

                if (accountable_purchase === 'no') {
                  if($(this).hasClass('dafiti-exchange')) {
                      exchangeMessageModal(exchangeModalJustMessage('Somente o titular da conta pode receber a restituição.'), '320,109');
                      return;
                    }

                  alert('Somente o titular da conta pode receber a restituição.');
                  return;
                }

                if (joint_account === 'no') {
                  if($(this).hasClass('dafiti-exchange')) {
                      exchangeMessageModal(exchangeModalJustMessage('Somente o primeiro titular da conta pode receber a restituição.'), '320,109');
                      return;
                    }

                  alert('Somente o titular da conta pode receber a restituição.');
                  return;
                }

                if (bank == '') {

                    $('#OrderForm_bank').focus();

                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Por favor, selecione o banco para prosseguir com a restituição.'), '320,109');
                        return;
                    }

                    alert('Por favor, selecione o banco para prosseguir com a restituição.');
                    return;
                }

                agency = $("#OrderForm_agency").val();
                agencyDigit = $("#OrderForm_agencyDigit").val();
                if (agency == '') {

                    $('#OrderForm_agency').focus();

                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Por favor, digite o número da agência.'), '320,109');
                        return;
                    }

                    alert('Por favor, digite o número da agência.');
                    return;
                }

                account = $("#OrderForm_account").val();
                accountDigit = $("#OrderForm_accountDigit").val();
                if (account == '') {

                    $('#OrderForm_account').focus();

                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Por favor, digite o número da conta.'), '320,109');
                        return;
                    }

                    alert('Por favor, digite o número da conta.');
                    return;
                }

                accountType = $('input[name="OrderForm[account_type]"]:checked').val();
                if ( (accountType == undefined) && (account != undefined) ) {

                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Escolha o tipo de conta'), '320,109');
                        return;
                    }


                    alert('Escolha o tipo de conta');
                    return;
                }

                if(bank) {
                  var resultBankvalidator = undefined;

                  if(!(banksArray instanceof Object))
                    banksArray = JSON.parse(banksArray);

                  var bankCode = getBankCode(banksArray[bank]);

                  Moip.BankAccount.validate({
                      bankNumber         : bankCode,
                      agencyNumber       : agency,
                      agencyCheckNumber  : agencyDigit,
                      accountNumber      : account,
                      accountCheckNumber : accountDigit,
                      valid: function() {},
                      invalid: function(data) {
                        var errors = "Conta bancária inválida: \n";
                        for(i in data.errors){
                          errors += data.errors[i].description + ")\n";
                        }
                        alert(errors);
                        resultBankvalidator = errors;
                      }
                    });

                    if(resultBankvalidator != undefined)
                      return;
                }
            }

        }

        var order_id = $('#order_id_hidden').text();
        var item_id = $('#item_id_hidden').text();
        var reason_id = $('#reason_id_hidden').text();
        var total_value = $('#total_value_hidden').text();
        var selectedSku = $('#new_sku').text();

        var id_return_point = $('#id_return_point_hidden').text();
        var return_phone = $('#return_phone_hidden').text();

        if (devolutionMethod === 'convenience') {
          if (id_return_point === '' || return_phone === '') {
            alert('Selecione o ponto de devolução e preencha o telefone');
            return;
          }
        }

        $(".button").prop('disabled',true);
        $(".button").css('color', '#AFAFAF');
        $('.loadingRequest').toggle();

        $.ajax({
            url:'/customer/order/ExchangeReturnFinish/',
            data:{
                'order_id':order_id,
                'item_id':item_id,
                'reason_id':reason_id,
                'totalValue':total_value,
                'reasonTextarea':reasonTextarea,
                'devolutionMethod':devolutionMethod,
                'packageOption':packageOption,
                'replacementMethods':replacementMethods,
                'type_refund': type_refund_value,
                'bank':bank,
                'agency':agency,
                'agencyDigit':agencyDigit,
                'account':account,
                'accountDigit':accountDigit,
                'accountType':accountType,
                'selectedSku':selectedSku,
                'id_return_point': id_return_point,
                'return_phone': return_phone
            },
            success: function(){
              openModal(
                '/customer/order/exchangereturnsuccess/',
                '/customer/order/listforexchange/?utm_source=organic&utm_medium=trocas_devolucoes&utm_campaign=solicitacao_sucesso'
              );
            },
            error: function(){
              openModal(
                '/customer/order/exchangereturnfailure/',
                '/customer/order/listforexchange/?utm_source=organic&utm_medium=trocas_devolucoes&utm_campaign=solicitacao_erro'
              );
            }
        });
    });

});

function openModal(remote, redirectCloseModal) {
  $('body').modal('destroy');
  $('body').removeData('dft.modal');
  $('body').modal({
      'remote': remote,
      'className' : 'exchangereturn_modal',
      'redirectCloseModal': redirectCloseModal
  });
}

var newPoints = [];
var ufs = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO',]

function filter() {
  var uf = document.getElementById("selectUf").value;
  var city = document.getElementById("devolutionCity").value;

  var points = [];

  if (uf) {
    points = filterByUf(uf);
  }

  if (city && city.length >= 3) {
    var pointsSearch = uf ? points : easyPoints;
    points = filterByCity(city, pointsSearch);
  }

  if (!uf && !city) {
    points = easyPoints;
  }

  showPoints(points);
}

function filterByCity(city, points) {
  var pointsFilted = [];
  points.forEach(function(point, index) {
    var cityEasyPointParse = clearText(point.CITY);
    var cityParse = clearText(city);
    var check = cityEasyPointParse.indexOf(cityParse);

    if (check >= 0) {
      pointsFilted.push(point);
    }
  })
  return pointsFilted;
}

function filterByUf(uf) {
  var points = [];

  easyPoints.forEach(function(point, index) {
    if (point.UF == uf) {
      points.push(point);
    }
  })
  return points;
}

function mountSelectUF() {
  var nodeUf = document.getElementById("selectUf");
  var htmlSelectUf = '<option value="">-- Selecione um estado --</option>';
  for (var index = 0; index < ufs.length; index++) {
    htmlSelectUf += '<option value="'+ufs[index]+'">'+ufs[index]+'</option>';
  }
  nodeUf.innerHTML = htmlSelectUf;
}

function showPoints(points) {
  var node = document.getElementById("col");
  var html = "";
  var count = 0;

  if (points) {
    points.forEach(function(point, index){
      html += mountHtmlPoint(point, index);
    });
  }
  node.innerHTML = html;
}

function mountHtmlPoint(point, index) {
  var html = "";
  html += '<div id="select' + (index+1) + '" class="select" style="padding: 10px 10px 10px 10px; overflow: auto;" onmouseover="selectDevolution(' + (index+1) + ');" onmouseout="unselectDevolution(event, ' + (index + 1) + ');">';
  html += '<span id="name' + (index + 1) + '">' + point.NAME + '</span>';
  html += '<div style="height: 5px;">&nbsp;</div>';
  html += '<span id="address' + (index + 1) + '" style="color: #858585;">' + point.ADDRESS + ', ' + point.NUMBER + '</span>';
  html += '<br><span id="district' + (index + 1) + '" style="color: #858585;">' + point.DISTRICT + ' - ' + point.CITY + ' - ' + point.UF + '</span>';
  html += '<div style="height: 5px;">&nbsp;</div>';
  html += '<div>';
  html += '  <div style="float: left; padding: 0 0 10px 0">';
  html += '    <span id="time' + (index + 1) + '">' + point.TIMEAVAILABLE + '</span>';
  html += '    </div>';
  html += '    <div style="text-align: right;">&nbsp;';
  html += '      <button id="button' + (index + 1) + '" style="display: none;" type="button" class="dft button primary" onclick="showConfirm(' + (index+1) + ',\'#confirm' + (index + 1) + '\', \'#button' + (index + 1) + '\', \'#select' + (index + 1) + '\');">Selecione</button>';
  html += '    </div>';
  html += '</div>'
  html += '<div id="confirm' + (index + 1) + '" style="display: none">';
  html += '  <hr style="width: 100%; height: 1px; border: 0; border-top: 1px dotted #DDDDDD; padding: 0; margin: 0;">';
  html += '  <div style="height: 5px;">&nbsp;</div>';
  html += '      <div>';
  html += '    Telefone celular*';
  html += '  </div>';
  html += '  <div>';
  html += '    <div style="float:left;"><input id="phone' + (index + 1) + '" type="text" placeholder="(00) 00000-0000" class="form__input" style="margin: 10px 0 10px 0;" maxlength="15" onkeypress="maskTel(this, \'#confirm-error' + (index + 1) + '\');"></input></div>';
  html += '    <div style="text-align: right;"><button id="confirm' + (index + 1) + '" class="dft button primary" onclick="if (checkPhone(\'#confirm-error' + (index + 1) + '\', ' + (index + 1) + ')) { $(\'body\').modal(\'close\'); appendElement(' + (index + 1) + ',' + point.ID_PICKUP_ADDRESS + ');}">Confirmar</button></div>';
  html += '  </div>'
  html += '</div>'
  html += '  <div id="confirm-error' + (index + 1) + '" style="display:none; clear: left; text-align: left; float:left; color:#FF0000; background-color: #F0F0F0;">Preencha o campo</div>';
  html += '</div>'
  html += '<hr style="width: 100%; height: 1px; border: 0; border-top: 1px solid #DDDDDD; margin: 0;">';

  return html;
}

function clearText(string) {
  return (string.normalize('NFD').replace(/[\u0300-\u036f]/g, "")).toUpperCase();
}

function clearFilter() {
  showPoints(easyPoints);
}

function addOpacityUnselectedDevolutionsMethod(topicId) {
  if (topicId !== 'post') {
      $('#post').addClass('opacity');
  }

  if (topicId !== 'collect') {
      $('#collect').addClass('opacity');
  }

  if (topicId !== 'convenience') {
      $('#convenience').addClass('opacity');
  }
}

function changeIconForSelectedDevolutionsMethod(imageId) {
  if (imageId !== 'post_icon') {
      $('#post_icon').attr('src', 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTMxLjMgMzguMjV2NC4xcTAgLjc1LS42IDEuMi0uNi40NS0xLjQuNDVINS42NXEtLjcgMC0xLjE3NS0uNDc1UTQgNDMuMDUgNCA0Mi4zNXYtMTQuOXEwLS43LjQ3NS0xLjE3NS40NzUtLjQ3NSAxLjE3NS0uNDc1aDYuNjVWMTUuNXEwLTQuODUgMy40MjUtOC4xNzVRMTkuMTUgNCAyNCA0aDguNjVxNC43NSAwIDguMDUgMy4zNzVRNDQgMTAuNzUgNDQgMTUuNVY0NGgtM3YtNS43NVptMC0zSDQxVjE1LjVxMC0zLjUtMi40MjUtNlQzMi42NSA3SDI0cS0zLjYgMC02LjE1IDIuNDUtMi41NSAyLjQ1LTIuNTUgNi4wNXYxMC4zaDE0cS44IDAgMS40LjQ1LjYuNDUuNiAxLjJabS0xMS4zLTE2di0zaDE2LjN2M1pNMTcuNjUgMzQuOWwxMC42NS02LjFIN1ptMCAyLjc1TDcgMzEuNTVWNDFoMjEuM3YtOS40NVpNNyAyOC44VjQxIDI4LjhaIj48L3BhdGg+PC9zdmc+');
  }

  if (imageId !== 'collect_icon') {
      $('#collect_icon').attr('src', 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTExLjIgMzkuOTVxLTIuNDUgMC00LjE3NS0xLjcyNVE1LjMgMzYuNSA1LjMgMzQuMDVIMlYxMXEwLTEuMi45LTIuMVEzLjggOCA1IDhoMjguOTV2OC4zNWg1LjI1TDQ2IDI1LjR2OC42NWgtMy41NXEwIDIuNDUtMS43MjUgNC4xNzVRMzkgMzkuOTUgMzYuNTUgMzkuOTVxLTIuNDUgMC00LjE3NS0xLjcyNVEzMC42NSAzNi41IDMwLjY1IDM0LjA1SDE3LjFxMCAyLjQ1LTEuNzI1IDQuMTc1UTEzLjY1IDM5Ljk1IDExLjIgMzkuOTVabTAtM3ExLjIgMCAyLjA1LS44NS44NS0uODUuODUtMi4wNSAwLTEuMi0uODUtMi4wNS0uODUtLjg1LTIuMDUtLjg1LTEuMiAwLTIuMDUuODUtLjg1Ljg1LS44NSAyLjA1IDAgMS4yLjg1IDIuMDUuODUuODUgMi4wNS44NVpNNSAzMS4wNWgxLjFxLjg1LTEuMzUgMi4xNS0yLjE1IDEuMy0uOCAyLjktLjggMS42IDAgMi45MjUuODI1IDEuMzI1LjgyNSAyLjE3NSAyLjEyNWgxNC43VjExSDVabTMxLjU1IDUuOXExLjIgMCAyLjA1LS44NS44NS0uODUuODUtMi4wNSAwLTEuMi0uODUtMi4wNS0uODUtLjg1LTIuMDUtLjg1LTEuMiAwLTIuMDUuODUtLjg1Ljg1LS44NSAyLjA1IDAgMS4yLjg1IDIuMDUuODUuODUgMi4wNS44NVptLTIuNi0xMC4yaDkuM2wtNS41NS03LjRoLTMuNzVaTTE4IDIxLjU1WiI+PC9wYXRoPjwvc3ZnPg==');
  }

  if (imageId !== 'convenience_icon') {
      $('#convenience_icon').attr('src', 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTE4LjUgMjUuNXYtOS4yNUwyNCAxMi42bDUuNSAzLjY1djkuMjVoLTN2LTZoLTV2NlpNMjQgNDAuMDVxNi42NS02LjA1IDkuODI1LTEwLjk3NVEzNyAyNC4xNSAzNyAyMC40cTAtNS45LTMuNzc1LTkuNjVUMjQgN3EtNS40NSAwLTkuMjI1IDMuNzVRMTEgMTQuNSAxMSAyMC40cTAgMy43NSAzLjI1IDguNjc1UTE3LjUgMzQgMjQgNDAuMDVaTTI0IDQ0cS04LjA1LTYuODUtMTIuMDI1LTEyLjcyNVE4IDI1LjQgOCAyMC40cTAtNy41IDQuODI1LTExLjk1UTE3LjY1IDQgMjQgNHE2LjM1IDAgMTEuMTc1IDQuNDVRNDAgMTIuOSA0MCAyMC40cTAgNS0zLjk3NSAxMC44NzVUMjQgNDRaIj48L3BhdGg+PC9zdmc+');
  }

  if (imageId == 'post_icon') {
      $('#post_icon').attr('src', 'data:image/svg+xml;base64,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');
  }

  if (imageId == 'collect_icon') {
      $('#collect_icon').attr('src', 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgaGVpZ2h0PSI0OCIKICAgd2lkdGg9IjQ4IgogICB2ZXJzaW9uPSIxLjEiCiAgIGlkPSJzdmcyNzQiCiAgIHNvZGlwb2RpOmRvY25hbWU9ImxvY2FsX3NoaXBwaW5nX3doaXRlLnN2ZyIKICAgaW5rc2NhcGU6dmVyc2lvbj0iMS4yLjIgKDczMmEwMWRhNjMsIDIwMjItMTItMDksIGN1c3RvbSkiCiAgIHhtbG5zOmlua3NjYXBlPSJodHRwOi8vd3d3Lmlua3NjYXBlLm9yZy9uYW1lc3BhY2VzL2lua3NjYXBlIgogICB4bWxuczpzb2RpcG9kaT0iaHR0cDovL3NvZGlwb2RpLnNvdXJjZWZvcmdlLm5ldC9EVEQvc29kaXBvZGktMC5kdGQiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGRlZnMKICAgICBpZD0iZGVmczI3OCIgLz4KICA8c29kaXBvZGk6bmFtZWR2aWV3CiAgICAgaWQ9Im5hbWVkdmlldzI3NiIKICAgICBwYWdlY29sb3I9IiNmZmZmZmYiCiAgICAgYm9yZGVyY29sb3I9IiMwMDAwMDAiCiAgICAgYm9yZGVyb3BhY2l0eT0iMC4yNSIKICAgICBpbmtzY2FwZTpzaG93cGFnZXNoYWRvdz0iMiIKICAgICBpbmtzY2FwZTpwYWdlb3BhY2l0eT0iMC4wIgogICAgIGlua3NjYXBlOnBhZ2VjaGVja2VyYm9hcmQ9IjAiCiAgICAgaW5rc2NhcGU6ZGVza2NvbG9yPSIjZDFkMWQxIgogICAgIHNob3dncmlkPSJmYWxzZSIKICAgICBpbmtzY2FwZTp6b29tPSIxNi40MTY2NjciCiAgICAgaW5rc2NhcGU6Y3g9IjI0LjA5MTM3MSIKICAgICBpbmtzY2FwZTpjeT0iMjQiCiAgICAgaW5rc2NhcGU6d2luZG93LXdpZHRoPSIxOTIwIgogICAgIGlua3NjYXBlOndpbmRvdy1oZWlnaHQ9IjEwNDMiCiAgICAgaW5rc2NhcGU6d2luZG93LXg9IjAiCiAgICAgaW5rc2NhcGU6d2luZG93LXk9IjAiCiAgICAgaW5rc2NhcGU6d2luZG93LW1heGltaXplZD0iMSIKICAgICBpbmtzY2FwZTpjdXJyZW50LWxheWVyPSJzdmcyNzQiIC8+CiAgPHBhdGgKICAgICBkPSJNMTEuMiAzOS45NXEtMi40NSAwLTQuMTc1LTEuNzI1UTUuMyAzNi41IDUuMyAzNC4wNUgyVjExcTAtMS4yLjktMi4xUTMuOCA4IDUgOGgyOC45NXY4LjM1aDUuMjVMNDYgMjUuNHY4LjY1aC0zLjU1cTAgMi40NS0xLjcyNSA0LjE3NVEzOSAzOS45NSAzNi41NSAzOS45NXEtMi40NSAwLTQuMTc1LTEuNzI1UTMwLjY1IDM2LjUgMzAuNjUgMzQuMDVIMTcuMXEwIDIuNDUtMS43MjUgNC4xNzVRMTMuNjUgMzkuOTUgMTEuMiAzOS45NVptMC0zcTEuMiAwIDIuMDUtLjg1Ljg1LS44NS44NS0yLjA1IDAtMS4yLS44NS0yLjA1LS44NS0uODUtMi4wNS0uODUtMS4yIDAtMi4wNS44NS0uODUuODUtLjg1IDIuMDUgMCAxLjIuODUgMi4wNS44NS44NSAyLjA1Ljg1Wk01IDMxLjA1aDEuMXEuODUtMS4zNSAyLjE1LTIuMTUgMS4zLS44IDIuOS0uOCAxLjYgMCAyLjkyNS44MjUgMS4zMjUuODI1IDIuMTc1IDIuMTI1aDE0LjdWMTFINVptMzEuNTUgNS45cTEuMiAwIDIuMDUtLjg1Ljg1LS44NS44NS0yLjA1IDAtMS4yLS44NS0yLjA1LS44NS0uODUtMi4wNS0uODUtMS4yIDAtMi4wNS44NS0uODUuODUtLjg1IDIuMDUgMCAxLjIuODUgMi4wNS44NS44NSAyLjA1Ljg1Wm0tMi42LTEwLjJoOS4zbC01LjU1LTcuNGgtMy43NVpNMTggMjEuNTVaIgogICAgIGlkPSJwYXRoMjcyIgogICAgIHN0eWxlPSJmaWxsOiNmZmZmZmYiIC8+Cjwvc3ZnPgo=');
  }

  if (imageId == 'convenience_icon') {
      $('#convenience_icon').attr('src', 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgaGVpZ2h0PSI0OCIKICAgd2lkdGg9IjQ4IgogICB2ZXJzaW9uPSIxLjEiCiAgIGlkPSJzdmcyMCIKICAgc29kaXBvZGk6ZG9jbmFtZT0iaG9tZV9waW5fd2hpdGUuc3ZnIgogICBpbmtzY2FwZTp2ZXJzaW9uPSIxLjIuMiAoNzMyYTAxZGE2MywgMjAyMi0xMi0wOSwgY3VzdG9tKSIKICAgeG1sbnM6aW5rc2NhcGU9Imh0dHA6Ly93d3cuaW5rc2NhcGUub3JnL25hbWVzcGFjZXMvaW5rc2NhcGUiCiAgIHhtbG5zOnNvZGlwb2RpPSJodHRwOi8vc29kaXBvZGkuc291cmNlZm9yZ2UubmV0L0RURC9zb2RpcG9kaS0wLmR0ZCIKICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZGVmcwogICAgIGlkPSJkZWZzMjQiIC8+CiAgPHNvZGlwb2RpOm5hbWVkdmlldwogICAgIGlkPSJuYW1lZHZpZXcyMiIKICAgICBwYWdlY29sb3I9IiNmZmZmZmYiCiAgICAgYm9yZGVyY29sb3I9IiMwMDAwMDAiCiAgICAgYm9yZGVyb3BhY2l0eT0iMC4yNSIKICAgICBpbmtzY2FwZTpzaG93cGFnZXNoYWRvdz0iMiIKICAgICBpbmtzY2FwZTpwYWdlb3BhY2l0eT0iMC4wIgogICAgIGlua3NjYXBlOnBhZ2VjaGVja2VyYm9hcmQ9IjAiCiAgICAgaW5rc2NhcGU6ZGVza2NvbG9yPSIjZDFkMWQxIgogICAgIHNob3dncmlkPSJmYWxzZSIKICAgICBpbmtzY2FwZTp6b29tPSIxNi40MTY2NjciCiAgICAgaW5rc2NhcGU6Y3g9IjI0LjIxMzE5OCIKICAgICBpbmtzY2FwZTpjeT0iMjQuMDYwOTE0IgogICAgIGlua3NjYXBlOndpbmRvdy13aWR0aD0iMTkyMCIKICAgICBpbmtzY2FwZTp3aW5kb3ctaGVpZ2h0PSIxMDQzIgogICAgIGlua3NjYXBlOndpbmRvdy14PSIwIgogICAgIGlua3NjYXBlOndpbmRvdy15PSIwIgogICAgIGlua3NjYXBlOndpbmRvdy1tYXhpbWl6ZWQ9IjEiCiAgICAgaW5rc2NhcGU6Y3VycmVudC1sYXllcj0ic3ZnMjAiIC8+CiAgPHBhdGgKICAgICBkPSJNMTguNSAyNS41di05LjI1TDI0IDEyLjZsNS41IDMuNjV2OS4yNWgtM3YtNmgtNXY2Wk0yNCA0MC4wNXE2LjY1LTYuMDUgOS44MjUtMTAuOTc1UTM3IDI0LjE1IDM3IDIwLjRxMC01LjktMy43NzUtOS42NVQyNCA3cS01LjQ1IDAtOS4yMjUgMy43NVExMSAxNC41IDExIDIwLjRxMCAzLjc1IDMuMjUgOC42NzVRMTcuNSAzNCAyNCA0MC4wNVpNMjQgNDRxLTguMDUtNi44NS0xMi4wMjUtMTIuNzI1UTggMjUuNCA4IDIwLjRxMC03LjUgNC44MjUtMTEuOTVRMTcuNjUgNCAyNCA0cTYuMzUgMCAxMS4xNzUgNC40NVE0MCAxMi45IDQwIDIwLjRxMCA1LTMuOTc1IDEwLjg3NVQyNCA0NFoiCiAgICAgaWQ9InBhdGgxOCIKICAgICBzdHlsZT0iZmlsbDojZmZmZmZmIiAvPgo8L3N2Zz4K');
  }
}

function addOpacityUnselectedReplacementMethod(topicId) {
  if (topicId !== 'voucher') {
      $('#voucher').addClass('opacity');
  }

  if (topicId !== 'exchange-id') {
      $('#exchange-id').addClass('opacity');
  }

  if (topicId !== 'refund') {
      $('#refund').addClass('opacity');
  }
}

function changeIconSelectedReplacementMethod(imageId) {
  if (imageId !== 'voucher_icon') {
      $('#voucher_icon').attr('src', 'data:image/svg+xml;base64,PHN2ZyBpZD0iSWNvbnMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMyIDMyOyIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMzIgMzIiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGQ9Ik0yOS41LDEzLjRjMC4zLTAuMiwwLjUtMC41LDAuNS0wLjlWMTBjMC0xLjEtMC45LTItMi0yaC02LjNjLTAuNCwwLTAuNywwLjItMC45LDAuNWMtMC40LDAuNi0xLjMsMC42LTEuNywwICBDMTksOC4yLDE4LjYsOCwxOC4zLDhINGMtMS4xLDAtMiwwLjktMiwydjIuNmMwLDAuNCwwLjIsMC43LDAuNSwwLjlDMy40LDE0LDQsMTQuOSw0LDE2cy0wLjYsMi0xLjUsMi42QzIuMiwxOC44LDIsMTkuMSwyLDE5LjRWMjIgIGMwLDEuMSwwLjksMiwyLDJoMTQuM2MwLjQsMCwwLjctMC4yLDAuOS0wLjVjMC40LTAuNiwxLjMtMC42LDEuNywwYzAuMiwwLjMsMC41LDAuNSwwLjksMC41SDI4YzEuMSwwLDItMC45LDItMnYtMi42ICBjMC0wLjQtMC4yLTAuNy0wLjUtMC45QzI4LjYsMTgsMjgsMTcuMSwyOCwxNlMyOC42LDE0LDI5LjUsMTMuNHogTTEyLDE5LjlMMTIsMTkuOWMwLDAuNi0wLjQsMS4xLTEsMS4xcy0xLTAuNC0xLTEgIGMtMC42LDAtMS0wLjQtMS0xczAuNC0xLDEtMWgxLjVjMC4zLDAsMC41LTAuMiwwLjUtMC41UzExLjgsMTcsMTEuNSwxN2gtMUM5LjEsMTcsOCwxNS45LDgsMTQuNWMwLTEuMiwwLjktMi4yLDItMi40VjEyICBjMC0wLjYsMC40LTEsMS0xczEsMC40LDEsMWMwLjYsMCwxLDAuNCwxLDFzLTAuNCwxLTEsMWgtMS41Yy0wLjMsMC0wLjUsMC4yLTAuNSwwLjVzMC4yLDAuNSwwLjUsMC41aDFjMS40LDAsMi41LDEuMSwyLjUsMi41ICBDMTQsMTguNywxMy4xLDE5LjcsMTIsMTkuOXogTTIxLDE5YzAsMC42LTAuNCwxLTEsMXMtMS0wLjQtMS0xdi0xYzAtMC42LDAuNC0xLDEtMXMxLDAuNCwxLDFWMTl6IE0yMSwxNGMwLDAuNi0wLjQsMS0xLDEgIHMtMS0wLjQtMS0xdi0xYzAtMC42LDAuNC0xLDEtMXMxLDAuNCwxLDFWMTR6Ij48L3BhdGg+PC9zdmc+');
  }

  if (imageId !== 'replace_icon') {
      $('#replace_icon').attr('src', 'data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE3OTIiIHZpZXdCb3g9IjAgMCAxNzkyIDE3OTIiIHdpZHRoPSIxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNzkyIDExODR2MTkycTAgMTMtOS41IDIyLjV0LTIyLjUgOS41aC0xMzc2djE5MnEwIDEzLTkuNSAyMi41dC0yMi41IDkuNXEtMTIgMC0yNC0xMGwtMzE5LTMyMHEtOS05LTktMjIgMC0xNCA5LTIzbDMyMC0zMjBxOS05IDIzLTkgMTMgMCAyMi41IDkuNXQ5LjUgMjIuNXYxOTJoMTM3NnExMyAwIDIyLjUgOS41dDkuNSAyMi41em0wLTU0NHEwIDE0LTkgMjNsLTMyMCAzMjBxLTkgOS0yMyA5LTEzIDAtMjIuNS05LjV0LTkuNS0yMi41di0xOTJoLTEzNzZxLTEzIDAtMjIuNS05LjV0LTkuNS0yMi41di0xOTJxMC0xMyA5LjUtMjIuNXQyMi41LTkuNWgxMzc2di0xOTJxMC0xNCA5LTIzdDIzLTlxMTIgMCAyNCAxMGwzMTkgMzE5cTkgOSA5IDIzeiI+PC9wYXRoPjwvc3ZnPg==');
  }

  if (imageId !== 'refund_icon') {
      $('#refund_icon').attr('src', 'data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMiAzMiIgaWQ9IlN0b2NrX2N1dCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMzIgMzIiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZXNjPjwvZGVzYz48Zz48cGF0aCBkPSJNMjIsNUg1ICAgQzMuODk1LDUsMyw1Ljg5NSwzLDd2MjJjMCwxLjEwNSwwLjg5NSwyLDIsMmgxOGMxLjEwNSwwLDItMC44OTUsMi0yVjE4IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIj48L3BhdGg+PHBhdGggZD0iTTksMTRIM3Y4aDYgICBjMi4yMDksMCw0LTEuNzkxLDQtNHYwQzEzLDE1Ljc5MSwxMS4yMDksMTQsOSwxNHoiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiPjwvcGF0aD48Y2lyY2xlIGN4PSI5IiBjeT0iMTgiIHI9IjEiPjwvY2lyY2xlPjxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiIHgxPSIyNSIgeDI9IjI1IiB5MT0iMCIgeTI9IjE1Ij48L2xpbmU+PHBvbHlsaW5lIGZpbGw9Im5vbmUiIHBvaW50cz0iMTksOSAyNSwxNSAzMSw5ICAgICAiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiPjwvcG9seWxpbmU+PC9nPjwvc3ZnPg==');
  }

  if (imageId == 'voucher_icon') {
    $('#voucher_icon').attr('src', 'data:image/svg+xml;base64,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');
  }

  if (imageId == 'replace_icon') {
      $('#replace_icon').attr('src', 'data:image/svg+xml;base64,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');
  }

  if (imageId == 'refund_icon') {
      $('#refund_icon').attr('src', 'data:image/svg+xml;base64,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');
  }
}

function verifyOptionsIsSelectedAndChangeConfirmButtonState() {
    var replacementMethods = $('input[name="OrderForm[replacement_methods]"]:checked').val();

    if (replacementMethods == undefined) {
        $('#submit_exchange_request').attr('disabled', true);
        $('#submit_exchange_request').removeClass('primary');
    }

    if (replacementMethods !== undefined) {
        $('#submit_exchange_request').attr('disabled', false)
        $('#submit_exchange_request').addClass('primary');
    }
}

function verifyOptionsIsSelectedIsCollect(id) {
    if (id === 'collect') {
        $('#selectedPlaceCollect').show();
    }

    if (id != 'collect') {
        $('#selectedPlaceCollect').hide();
    }
}
